import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { notNullOrEmpty } from '../../utils/common';
import { ImageLoader } from '../imageLoader';
import { LabelAndValue } from '../labelAndValue';

const useStyles = makeStyles({ name: 'EmobilityEngineSelectContent' })(theme => ({
	image: {
		height: 'auto',
		marginRight: 0,
		'&.large': {
			width: 110,
			marginLeft: -20,
			transform: 'translateY(-4px)'
		},
		'&.small': {
			width: 85,
			marginLeft: -15
		}
	},
	titlePanel: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		overflow: 'hidden'
	},
	title: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontWeight: 'bold',
		'&.small': {
			fontSize: '16px',
			lineHeight: '18px'
		},
		'&.medium': {
			fontSize: '18px',
			lineHeight: '20px'
		},
		'&.large': {
			fontSize: '24px',
			lineHeight: '26px'
		}
	},
	subtitle: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontWeight: 'bold',
		'&.small': {
			fontSize: '14px',
			lineHeight: '16px'
		},
		'&.medium': {
			fontSize: '14px',
			lineHeight: '16px'
		},
		'&.large': {
			fontSize: '16px',
			lineHeight: '18px'
		}
	},
	panelValueItems: {
		display: 'flex',
		marginLeft: 15
	},
	valueItem: {
		marginRight: 15,
		'&.small': {
			minWidth: 73,
			fontSize: '14px',
			lineHeight: '16px'
		},
		'&.small-wide': {
			minWidth: 129,
			fontSize: '14px',
			lineHeight: '16px'
		},
		'&.large': {
			fontSize: '16px',
			lineHeight: '28px',
			fontWeight: 'inherit'
		},
		'&:last-child': {
			marginRight: 0
		}
	}
}));

export type EmobilityEngineMenuItemContentProps = {
	title: string;
	subtitle?: string;
	titleVariant: 'small' | 'medium' | 'large';
	valueVariant: 'small' | 'small-wide' | 'large';
	imageVariant?: 'small' | 'large';
	battery?: {
		label?: string;
		value: string;
	};
	range?: {
		label?: string;
		value: string;
	};
	image?: {
		src: string;
		dummy: string;
	},
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
};

export const EmobilityEngineMenuItemContent: React.FC<EmobilityEngineMenuItemContentProps> = (props) => {
	const { image, title, subtitle, titleVariant, valueVariant, imageVariant, battery, range } = props;
	const { classes: styles, cx } = useStyles(undefined, { props });

	return (
		<React.Fragment>
			{notNullOrEmpty(image?.src) &&
				<ImageLoader
					width={600}
					height={337}
					className={cx(styles.image, imageVariant)}
					{...image}
					alt={title} />}
			<div className={styles.titlePanel}>
				<span data-test='car-title' className={cx(styles.title, titleVariant)}>
					{title}
				</span>
				{notNullOrEmpty(subtitle) &&
					<span data-test='car-subtitle' className={cx(styles.subtitle, titleVariant)}>
						{subtitle}
					</span>}
			</div>
			{(range || battery) &&
				<div
					data-test='container-values'
					className={styles.panelValueItems}>
					{range &&
						<LabelAndValue
							data-test='value-item-range'
							classes={{ root: cx(styles.valueItem, 'range', valueVariant) }}
							{...range} />}
					{battery &&
						<LabelAndValue
							data-test='value-item-battery'
							classes={{ root: cx(styles.valueItem, 'battery', valueVariant) }}
							{...battery} />}
				</div>}
		</React.Fragment>
	);
};

EmobilityEngineMenuItemContent.defaultProps = {
	imageVariant: 'large'
};